import _ from 'lodash';
import { getAuth, signOut } from 'firebase/auth';
import { queryClient } from '../../App';

export const handleInput = async (value, attribute, setInfo, setInfoError, schema) => {
  setInfo((prev) => ({ ...prev, [attribute]: value }));
  try {
    await schema.validateAt(attribute, { [attribute]: value });
    setInfoError((prev) => ({ ...prev, [attribute]: "" }));
  } catch (err) {
    setInfoError((prev) => ({ ...prev, [attribute]: err.message }));
  }
};

export const handleSubmit = async (data, schema, setInfoError, onSave) => {
  try {
    await schema.validate(data, { abortEarly: false });
    onSave(data);
    return null;
  } catch (err) {
    const validationErrors = err.inner?.length
      ? err.inner
      : [{ path: "_form", message: err.message || "Validation failed" }];
    const errors = validationErrors.reduce((acc, error) => {
      if (error.path) {
        _.set(acc, error.path, error.message);
      }
      return acc;
    }, {});
    setInfoError(errors);
    return errors;
  }
};

export function transformCamelToUnderscore(payload) {
    if (Array.isArray(payload)) {
        return payload.map(item => transformCamelToUnderscore(item));
    } else if (payload !== null && typeof payload === 'object') {
        return _.mapKeys(payload, (value, key) => _.snakeCase(key));
    }
    return payload;
}
export function transformUnderscoreToCamel(payload) {
    if (Array.isArray(payload)) {
        return payload.map(item => transformUnderscoreToCamel(item));
    } else if (payload !== null && typeof payload === 'object') {
        return _.mapKeys(payload, (value, key) => _.camelCase(key));
    }
    return payload;
}
export const capitalizeWords = (str) => {
  if (str) return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  else return str
}
export function logout() {
  const auth = getAuth();
  signOut(auth)
    .then(() => {
      localStorage.clear();
      queryClient.clear();
    })
    .catch(() => {});
}

export function formatErrors(errorObj, label = "Education") {
    const messages = [];

    Object.entries(errorObj).forEach(([key, message]) => {
        const match = key.match(/\[(\d+)\]\.(.+)/); // Extract index and field name
        if (match) {
            const index = parseInt(match[1], 10); // Convert string to number
            const field = match[2].replace(/_/g, " "); // Replace underscores with spaces
            messages.push(`${label} ${index+1}: ${message}
            `);
        } else {
            messages.push(message); // Fallback for non-matching keys
        }
    });

    return messages.join("\n"); // Combine messages into a single string
}

export function formatNestedErrors(errors, sectionName = "Item") {
  const result = [];

  for (const key in errors) {
    const match = key.match(/\[(\d+)\]\.(.+)/); // Matches [0].field_name
    if (match) {
      const index = parseInt(match[1], 10) + 1;
      const field = match[2]
        .replace(/_/g, " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()); // job_title → Job Title

      const message = errors[key];
      result.push(`${sectionName} ${index}: ${message}`);
    } else {
      // Fallback for flat keys
      result.push(errors[key]);
    }
  }

  return result;
}
